































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { getRecommend } from "@/api/cg/service/pinad_service";
import { GETTER_CLIENT_SETTINGS } from "@/store/constants/setting_types";
import { downloadApps } from "@/utils/app_download";
import PinadCoinAdd from "@/services/pinad_add_coin";
import { getInstalledList } from "@/jsbridge/service/commonMethod";
import listenNative from "@/jsbridge/service/listenNative";
import SwitchBackgroundPosition, {
  SwitchPositionTypes
} from "@/utils/switch_background/switch_background_position";
import Button from "@/components/Button/Button.vue";
import forceState from "@/services/super_pay/forceState";

@Component({
  components: {
    Button
  }
})
export default class HotApp extends Vue {
  private uninstalledApp: any = [];
  @Getter(GETTER_CLIENT_SETTINGS)
  private settingData: any;
  private isShowLoading: boolean = false;
  private isHotAppShow: boolean = false;

  // 加载服务器的hotapp数据
  private async refreshHotAppData() {
    try {
      // 如果之前有数据，每次拉取数据，不显示loading
      if (this.uninstalledApp.length === 0) {
        this.isShowLoading = true;
      }
      const res: any = await getRecommend();
      this.isShowLoading = false;
      if (res) {
        await this.filterInstalledApp(res);
      }
      this.isHotAppShow = this.uninstalledApp.length !== 0;
      PinadCoinAdd.addCoin();
    } catch (error) {
      this.isShowLoading = false;
      this.isHotAppShow = false;
      console.log(error);
    }
  }

  private async filterInstalledApp(recommendList: any) {
    try {
      const installAppList = await getInstalledList();
      this.uninstalledApp = recommendList.filter((item: any) => {
        return !item.has_install && !installAppList.includes(item.packageName);
      });
      console.log("uninstalledApp:", this.uninstalledApp);
    } catch (error) {
      console.log(error);
    }
  }

  private clickItem(item: any) {
    try {
      SwitchBackgroundPosition.setPosition(
        SwitchPositionTypes.REFRESH_CG_USER_INFO
      );
      downloadApps(item);
      forceState.set("force");
      // pinad start and set cache
      PinadCoinAdd.startAndSetCache(item);
    } catch (error) {
      console.log("hotapp download error", error);
    }
  }

  // 组件activated就加载数据，然后监听app进入前台事件再刷新数据。
  private activated() {
    this.refreshHotAppData();
    listenNative.addListen(
      "will_enter_foreground",
      () => {
        this.refreshHotAppData();
      },
      { key: "hot_app" }
    );
  }

  private created() {
    this.refreshHotAppData();
    listenNative.addListen(
      "will_enter_foreground",
      () => {
        this.refreshHotAppData();
      },
      { key: "hot_app" }
    );
  }

  // 组件销毁前必须去除对app进入前台事件的监听
  private beforeDestroy() {
    listenNative.removeListen("hot_app");
  }

  private deactivated() {
    listenNative.removeListen("hot_app");
  }

  private mounted() {
    this.$emit("loaded");
  }
}
